<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px">
        <v-row>
          <v-col cols="12" class="pa-8">
            <v-btn 
              @click="newEditionOrganizer()"
              color="primary">
              Nuevo Organizador
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              class="pt-8"
              :headers="headers"
              :items="edition_organizers"
              :custom-filter="customSearch"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Items por página',
              }"
              mobile="true"
            >
              <template v-slot:item.organizer="{ item }">
                <td>
                  {{ item.lastname.toUpperCase()+', '+ item.name }}
                </td>
              </template>

              <template v-slot:item.actions="{ item }">
                <td class="text-center">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="warning"
                    @click="editEditionOrganizer(item.id)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="confirmDeleteEditionOrganizer(item.id)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>
   
    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        color="primary"
        :to="{ name: 'showEditionOrganizers', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-eye
        </v-icon>
        Vista previa
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_delete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar este organizador?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading_btn"
            @click="deleteEditionOrganizer"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_new_organizer"
      width="540"
    >
      <v-card>
        <v-card-title class="text-h6">
          Nuevo organizador
        </v-card-title>

        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field outlined label="Apellido" v-model="lastname"></v-text-field>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field outlined label="Nombre" v-model="name"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="loading_btn"
            @click="dialog_new_organizer=!dialog_new_organizer"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!name||!lastname"
            :loading="loading_btn"
            @click="createEditionOrganizer"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_update_organizer"
      width="540"
    >
      <v-card>
        <v-card-title class="text-h6">
          Editar organizador
        </v-card-title>

        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field outlined label="Apellido" v-model="lastname"></v-text-field>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field outlined label="Nombre" v-model="name"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="loading_btn"
            @click="dialog_update_organizer=!dialog_update_organizer"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!name||!lastname"
            :loading="loading_btn"
            @click="updateEditionOrganizer"
          >
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'editionOrganizers',

    data: () => ({
      show:false,
      loading:true,
      loading_btn: false,
      
      dialog_delete:false,
      dialog_new_organizer:false,
      dialog_update_organizer:false,
      delete_id:null,
      name:'',
      lastname:'',

      edition_id: null,
      Edition:false,

      edition_organizers:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
      {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id',
          width: '5%'
        },
        {
          text: 'Organizador',
          align: 'start',
          sortable: true,
          value: 'organizer',
          width: '50%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '40%'
        }
      ]
    }),

    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },
      
      filterOnlyCapsText (value, search, item) {
        console.log(item)
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      async getEditionOrganizers()
      {
        await axios.get('admin/editions/'+this.edition_id+'/edition-organizers').then(response =>{
          this.edition_organizers = response.data.data.edition_organizers
          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      newEditionOrganizer(){
        this.name=''
        this.lastname=''
        this.dialog_new_organizer=true
      },

      async createEditionOrganizer(){
        try {
          this.loading_btn = true
          await axios.post('admin/editions/'+this.edition_id+'/edition-organizers',{
            name: this.name, 
            lastname: this.lastname, 
            edition_id: this.edition_id
            }).then(() =>{
              this.loading_btn = false
              this.dialog_new_organizer=false
              this.loading = true
              this.getEditionOrganizers() 
            })
          } catch (error) {
            this.loading_btn = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      },

      async editEditionOrganizer(id){
        this.loading=true
        await axios.get('admin/editions/'+this.edition_id+'/edition-organizers/'+id).then(response =>{
          this.edition_organizer_id=response.data.data.edition_organizer.id
          this.name=response.data.data.edition_organizer.name
          this.lastname=response.data.data.edition_organizer.lastname
          this.dialog_update_organizer=true
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      async updateEditionOrganizer(){
        try {
          this.loading_btn = true
          await axios.post('admin/editions/'+this.edition_id+'/edition-organizers/'+this.edition_organizer_id,{
            name: this.name, 
            lastname: this.lastname
            }).then(() =>{
              this.loading_btn = false
              this.dialog_update_organizer=false
              this.loading = true
              this.getEditionOrganizers() 
            })
          } catch (error) {
            this.loading_btn = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      },
      
      confirmDeleteEditionOrganizer(id)
      {
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteEditionOrganizer()
      {
        this.loading_btn = true
        try {  
          await axios.delete('admin/editions/'+this.edition_id+'/edition-organizers/'+this.delete_id).then(() =>{
            this.dialog_delete = false
            this.loading_btn =false
            this.loading=true
            this.delete_id = null
            this.loading = true
            this.getEditionOrganizers()
          })
        } catch (error) {
          console.error(error.response.data);
        }
      },
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.getEditionOrganizers()
    },
  }
</script>
